<!--
 * @Descripttion: 
 * @version: 
 * @Author: lrs
 * @Date: 2019-12-11 16:33:03
 * @LastEditors: mrh
 * @LastEditTime: 2020-07-23 14:38:03
 -->

<template>
  <div class="container">
    <van-tabbar v-model="active" active-color="#666" :before-change="beforeChange" @change="onChange">
      <van-tabbar-item v-for="(item,index) in tabList" :key="index">
        <span>{{item.tabName}}</span>
        <img slot="icon" :src="index == active ? item.active : item.inactive" />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabList: [
        {
          tabName: "我的店铺",
          path: "/shops",
          url: "/community/pages/myStore/myStore",
          active: require("../assets/img/tab_icon_home2.png"),
          inactive: require("../assets/img/tab_icon_home.png"),
        },
        {
          tabName: "我要推荐",
          path: "/search",
          url: "/community/pages/findGoods/findGoods",
          active: require("../assets/img/tab_icon_seach2.png"),
          inactive: require("../assets/img/tab_icon_seach.png"),
        },
        {
          tabName: "个人中心",
          path: "/personal",
          url: "/community/pages/personCenter/personCenter",
          active: require("../assets/img/tab_icon_my2.png"),
          inactive: require("../assets/img/tab_icon_my.png"),
        },
      ],
      active: 0,
    };
  },
  mounted() { },

  watch: {
    "$route.path":{
        handler(newV) {
          switch (newV) {
            case "/shops":
              this.active = 0;
              break;
            case "/search":
              this.active = 1;
              break;
            case "/personal":
              this.active = 2;
              break;
          }
      },
      immediate: true
    },
  },

  methods: {
    beforeChange(index) {
      if (this.$store.getters.ambientType == 0) {
        wx.miniProgram.redirectTo({ url: this.tabList[index].url });
      }
      return new Promise((resolve) => {
        // 在 resolve 函数中返回 true 或 false
        resolve(this.$store.getters.ambientType != 0);
      });
    },
    onChange(index) {
      this.active = index;
      this.$router.replace(this.tabList[index].path);
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/.van-tabbar-item__icon img {
  width: 29px;
  height: 29px;
}
.container {
  position: relative;
  z-index: 6;
}
</style>